var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-home vertical-layout"},[_c('Header'),_c('main',{staticClass:"main"},[_c('div',{staticClass:"narrow-container"},[_c('router-view')],1)]),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }